module.exports = __webpack_public_path__ + "img/qualita-dirompente-3.d48c9857.jpg";